import { useEffect, useState } from "react";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import { useRouter } from "next/router";
import { useI18n } from "@/i18n/I18nProvider";
import { styless } from "./user_dropDown";
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
import Popover from "@mui/material/Popover";
import UserMenu from "./UserMenu";
import { useDispatch, useSelector } from "react-redux";
import { userAction } from "@/Redux/store";
import jsonwebtoken from "jsonwebtoken";
import { api } from "@/utils/Axios";
import { EnvKey } from "@/utils/const";
import { FetchUserData } from "@/utils/Fetch_userDataFn";
import StarIcon from "@mui/icons-material/Star";
export default function UserDropDown({ onLogout }) {
  const router = useRouter();
  const { t } = useI18n();

  const name = useSelector((state) => state.user.name);
  const userId = useSelector((state) => state.user.id);
  const nationalID = useSelector((state) => state.user.nationalId);
  const avatar = useSelector((state) => state.user.avatar);
  const totalPoints = useSelector((state) => state.user.wallet.TotalPoints);
  const dispatch = useDispatch();
  const [Data, setData] = useState("");
  const [Loading, SetLoading] = useState(false);

  const fetchWalletData = async () => {
    if (!userId) return;

    try {
      const res = await api.get(`/wallets/${userId}`);
      dispatch(userAction.update({ key: "wallet", val: res.data }));
    } catch (err) {
      console.error("Error fetching wallet data:", err);
    }
  };
  useEffect(() => {
    if (!totalPoints && userId) {
      nationalID && fetchWalletData();
    }
  }, [userId]);
  const FetchData = async () => {
    let SessionData = jsonwebtoken.verify(
      localStorage.getItem("UT_UI"),
      EnvKey.secretKey,
    );
    let UserID = SessionData.id;
    FetchUserData(UserID, SetLoading, setData);
  };
  useEffect(() => {
    if (localStorage.getItem("UT_UI")) {
      if ((name == "" || avatar == "") && router.pathname !== "/contract") {
        FetchData();
      }
    }
  }, [name]);
  const handleLoyaltyClick = () => {
    const google_play_link =
      "https://play.google.com/store/apps/details?id=eg.contact";
    const app_store_link =
      "https://apps.apple.com/us/app/contactnow-%D9%83%D9%88%D9%86%D8%AA%D9%83%D8%AA/id1544159088";
    const userAgent =
      typeof navigator !== "undefined" ? navigator.userAgent : "";
    const isMobile = /iPhone|iPad|iPod|Android/i.test(userAgent);
    const isIOS = /iPhone|iPad|iPod/i.test(userAgent);
    const isAndroid = /Android/i.test(userAgent);

    if (isMobile) {
      const now = Date.now();
      window.location.href =
        "https://contacteg.page.link/?apn=eg.contact&ibi=eg.contact&link=https%3A%2F%2Fcontact.eg%2Fscreen%3Dloyaltypoints";
      setTimeout(() => {
        const elapsed = Date.now() - now;
        if (elapsed < 2000) {
          if (isIOS) {
            window.location.href = app_store_link;
          } else if (isAndroid) {
            window.location.href = google_play_link;
          } else {
            window.location.href = "https://connectnow.com/download";
          }
        }
      }, 1500);
    }
  };

  const userData = {
    image: avatar ? avatar : Data.avatar,
    user_name: name ? name?.split(" ")[0] : Data.name?.split(" ")[0],
  };
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        aria-label="user dropdown button"
        onClick={(e) => {
          setAnchorEl(e.currentTarget);
        }}
        sx={{
          ...styless.dropBox,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "0.25rem",
          }}
        >
          {}
          <Avatar
            src={userData.image}
            alt="User Avatar"
            sx={{ width: 24, height: 24 }}
          />
          <Box
            sx={{
              fontWeight: "700",
            }}
          >
            {!Loading ? (
              userData.user_name
            ) : (
              <CircularProgress
                color="inherit"
                size={15}
                sx={{ mt: 1 }}
              ></CircularProgress>
            )}
          </Box>
          <KeyboardArrowDown />
        </Box>
      </Button>
      {totalPoints != null &&
        (router.asPath === "/contract" ||
          router.asPath === "/customerservices" ||
          router.asPath === "/profile") && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
              mt: "4px",
              justifyContent: "center",
              cursor: "pointer",
            }}
            onClick={handleLoyaltyClick}
          >
            <>
              <StarIcon sx={{ color: "#2D317F", fontSize: "15px" }} />
              <Box sx={{ fontSize: "13px" }}>
                {`${totalPoints} ${t.userNav.loyaltyPoints}`}
              </Box>
            </>
          </Box>
        )}

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        sx={{ mt: 0.7 }}
      >
        <UserMenu onClose={handleClose} onLogout={onLogout} />
      </Popover>
    </>
  );
}
